const COMMON_FETCH_DIETS = {
  START: 'START_COMMON_FETCH_DIETS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_DIETS',
  FAIL: 'FAIL_COMMON_FETCH_DIETS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_DIETS',
}

export default COMMON_FETCH_DIETS
